// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Estilos de la Página de Suscripción */
.subscription-page {
    text-align: center;
    padding: 20px;
}

.subscription-page h1 {
    font-size: 2em;
    margin-bottom: 20px;
}

/* Estilos de los Planes de Suscripción */
.plans-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
}

.subscription-plan {
    background-color: rgb(236, 236, 236);
    border-radius: 12px;
    border: 1px solid rgb(187, 187, 187);
    padding: 20px;
    min-width: 200px;
    max-width: 300px;
    width: 80%;
    box-shadow: 0 8px 16px rgba(0,0,0,0.2);
    margin: 20px;
}

.subscription-plan h2 {
    font-size: 1.5em;
    margin-top: 0;
}

.subscription-plan h3 {
    font-size: 1.2em;
    margin-bottom: 10px;
}

.subscription-plan ul {
    list-style: none;
    padding: 0;
}

.subscription-plan li {
    text-align: left;
    margin-bottom: 8px;
}

.selected {
    cursor: pointer;
    transform: scale(1.05);
    background-color: black;
    color: white;
}

.subscription-plan:hover {
    cursor: pointer;
    transform: scale(1.05);
    background-color: black;
    color: white;
}

/* Pequeñas mejoras para pantallas más pequeñas */
@media (max-width: 600px) {
    .plans-container {
        flex-direction: column;
        align-items: center;
    }
}

.subscription-features {
}`, "",{"version":3,"sources":["webpack://./src/style/Register/Plans.css"],"names":[],"mappings":";AACA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,iDAAiD;AACjD;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA;AACA","sourcesContent":["\r\n/* Estilos de la Página de Suscripción */\r\n.subscription-page {\r\n    text-align: center;\r\n    padding: 20px;\r\n}\r\n\r\n.subscription-page h1 {\r\n    font-size: 2em;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n/* Estilos de los Planes de Suscripción */\r\n.plans-container {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.subscription-plan {\r\n    background-color: rgb(236, 236, 236);\r\n    border-radius: 12px;\r\n    border: 1px solid rgb(187, 187, 187);\r\n    padding: 20px;\r\n    min-width: 200px;\r\n    max-width: 300px;\r\n    width: 80%;\r\n    box-shadow: 0 8px 16px rgba(0,0,0,0.2);\r\n    margin: 20px;\r\n}\r\n\r\n.subscription-plan h2 {\r\n    font-size: 1.5em;\r\n    margin-top: 0;\r\n}\r\n\r\n.subscription-plan h3 {\r\n    font-size: 1.2em;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.subscription-plan ul {\r\n    list-style: none;\r\n    padding: 0;\r\n}\r\n\r\n.subscription-plan li {\r\n    text-align: left;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.selected {\r\n    cursor: pointer;\r\n    transform: scale(1.05);\r\n    background-color: black;\r\n    color: white;\r\n}\r\n\r\n.subscription-plan:hover {\r\n    cursor: pointer;\r\n    transform: scale(1.05);\r\n    background-color: black;\r\n    color: white;\r\n}\r\n\r\n/* Pequeñas mejoras para pantallas más pequeñas */\r\n@media (max-width: 600px) {\r\n    .plans-container {\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n}\r\n\r\n.subscription-features {\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
